import React from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Stack,
  useColorModeValue,
  useToken,
} from "@chakra-ui/react";
import { FiArrowRight } from "@react-icons/all-files/fi/FiArrowRight";
import { FiHexagon } from "@react-icons/all-files/fi/FiHexagon";

import { Link as GatsbyLink } from "gatsby";
import { HOME_PAGE_PX, HOME_PAGE_PY } from "./HomePage";
import { HomePageHeroImage } from "./HomePageHeroImage";

export function HomePageHero() {
  const { base, md } = HOME_PAGE_PY;
  const main_CTA_outline = useColorModeValue("blue.400", "orange.400");
  const main_CTA_BG = useColorModeValue("blue.100", "transparent");

  const gradientColors = useColorModeValue(
    useToken("colors", [
      "silver.200",
      "blue.100",
      "blue.100",
      "silver.100",
      "orange.100",
    ]),
    useToken("colors", ["black.300", "black.100", "black.200", "orange.600"])
  );
  return (
    <Flex
      direction="column"
      align="center"
      as="section"
      pt={{
        base,
        md,
      }}
      pb={HOME_PAGE_PY}
      px={HOME_PAGE_PX}
      bgImage={`linear-gradient(${["to bottom right", ...gradientColors]})`}
    >
      <Box
        mx="auto"
        w="full"
        maxW={720}
        mb="10"
        rounded="2xl"
        overflow="hidden"
        shadow="sm"
      >
        <HomePageHeroImage />
      </Box>
      <Heading
        mx="auto"
        textAlign="center"
        maxW={1000}
        as="h1"
        size="2xl"
        mb="2"
        lineHeight="normal"
      >
        GraphQL Tutorials
      </Heading>
      <Heading
        mx="auto"
        textAlign="center"
        maxW={1000}
        as="h2"
        size="lg"
        mb="8"
        lineHeight="normal"
      >
        Boost your developer skills with our hands-on GraphQL tutorials and
        trainings
      </Heading>
      <Stack
        mx="auto"
        align="center"
        direction={{
          base: "column",
          md: "row",
        }}
        spacing="4"
      >
        <Button
          size="lg"
          as={GatsbyLink}
          to="/browse"
          color={main_CTA_outline}
          borderColor={main_CTA_outline}
          bg={main_CTA_BG}
          borderRadius={"full"}
          variant="outline"
          rightIcon={<FiArrowRight />}
        >
          Browse tutorials
        </Button>
        <Button
          size="lg"
          as="a"
          href="#certifications"
          variant="outline"
          borderRadius={"full"}
          rightIcon={<FiHexagon />}
        >
          Explore certifications
        </Button>
      </Stack>
    </Flex>
  );
}
